export * from './date-config';

import InputField from '@plugins/text-field/input-field'
import Dropdown from '@plugins/dropdown/dropdown';
import Dropdown2 from '@plugins/dropdown/dropdown-2';
import TextField from '@plugins/text-field/text-field';
import TextField2 from '@plugins/text-field/text-field-2';
import DatePicker2 from '@plugins/text-field/date-picker-2';
import Checkbox2 from '@plugins/checkbox/checkbox-2';
import Radio2 from '@plugins/radio/radio-2';
import DBox from "@dtplugins/dbox/dbox";
import Modal from "@dtplugins/modal/modal";
import NTable from "@/plugins/datatable/datatable";
import { DTIconButton, IconButton } from "@plugins/button/button";
import DTCheckbox from "@plugins/checkbox/checkbox";
import SearchList from "@dtplugins/search-list/search-list";
// Global components will be absolutely necessary components that are used almost everywhere.

export const RegiserGlobalComponents = (Vue) => {
  Vue.component('InputField', InputField);
  Vue.component('Dropdown', Dropdown);
  Vue.component('Dropdown2', Dropdown2);
  Vue.component('TextField', TextField);
  Vue.component('TextField2', TextField2);
  Vue.component('DatePicker2', DatePicker2);
  Vue.component('Checkbox2', Checkbox2);
  Vue.component('Radio2', Radio2);
  Vue.component('DBox', DBox);
  Vue.component('Modal', Modal);
  Vue.component('NTable', NTable);
  Vue.component('DTIconButton', DTIconButton);
  Vue.component('IconButton', IconButton);
  Vue.component('DTCheckbox', DTCheckbox);
  Vue.component('SearchList', SearchList);
}

